/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const adDesignDataSchema = z.object({
	id: z.string(),
	organisationId: z.string(),
	name: z.string(),
	document: z.string(),
	thumbnailMediaId: z.string().nullable(),
	thumbnailUrl: z.string().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type AdDesignDataSchema = z.infer<typeof adDesignDataSchema>
